import "core-js/stable"
import "regenerator-runtime/runtime"
import _ from 'underscore';
import $ from 'jquery';
import moment from 'moment'
import {getBlog,getNews} from "../Api/sales.es6";
import {isLogin,logout,login,forceLogout} from "../Api/auth.es6";
import {getItem} from "../Api/items.es6";
console.log('v20210801-04');
window.onpageshow = function(evt) {
    if (evt.persisted) {
        location.reload();
    }
};
(function() {
    //初期化
    $(window).scroll(function (){
        $('.fadein').each(function(){
            let elemPos = $(this).offset().top,
                scroll = $(window).scrollTop(),
                windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 100){
                $(this).addClass('scrollin');
            }
        });
    });
    if ($(window).scrollTop() >= 1){
        $('.fadein').addClass('scrollin');
    }
    let auth;
    let user;
    let myLity;
    let scroll_top;
    let modal_id;
    $('#slide_pc_mac_0').fadeIn(0);
    $('#slide_pc_iphone_0').fadeIn(0);
    $('#slide_sp_0').fadeIn(0);
    moment.locale('ja');
    const $loader = $('#loader-wrap');
    $loader.css('display','none');
    isLogin()
        .then((result) => {
            switchHeaderIsLogin();
            //カートバッジ cartNumber
            const cartNumber = result.cart.details.length;
            $('#cartNumber').html(cartNumber);
            $('#cartNumberSp').html(cartNumber);
            //お気に入りバッジ favoriteTotal
            $('#favoriteTotal').html(result.favorite.total);
            $('#favoriteTotalSp').html(result.favorite.total);
            //SP ハンバーガー内リスト .shipping_history arrangeList append numOfArranged
            let numOfArranged = 0;
            if (result.arrangements.previous !== undefined) {
                numOfArranged = result.arrangements.previous.length;
                for (const list of result.arrangements.previous) {
                }
            }
            $('#numOfArranged').html(`(${numOfArranged})`);
            $loader.css('display','none');
        })
        .catch(() => {
            logout()
                .then(()=>{
                    switchHeaderIsLogout();
                })
                .catch(()=>{
                    forceLogout()
                        .then(()=>{
                            switchHeaderIsLogout();
                        })
                        .catch(()=>{
                            switchHeaderIsLogout();
                        })
                })
        });
    $('a.linkDisabled').click(function(){
        return false;
    });
    $('.goToLink').on('click',function () {
       const linkUrl = $(this).data('url');
       location.href = linkUrl;
    });
    $('.openTab').on('click',function () {
        const url = $(this).data('url');
        console.log(url);
        window.open(url, '_blank');
    });
    const switchHeaderIsLogin = () => {
        $('.isLogout').remove();
        $('.wrapper').fadeIn(10);
        triggerSwiper();
    };
    const switchHeaderIsLogout = () => {
        $('.isLogin').remove();
        $('.wrapper').fadeIn(10);
        triggerSwiper();
    };
    const triggerSwiper =()=>{
        if (window.matchMedia( "(max-width: 768px)" ).matches) {
            $('.p-topVoice__voiceList__voiceBox').on('click',function(){
                $(this).find('.p-topVoice__voiceList__voiceBox__textBox').slideToggle();
            });
        }
        $('.p-topSetContents__contentsBox__tabList li').click(function() {
            const index = $('.p-topSetContents__contentsBox__tabList li').index(this);
            $('.p-topSetContents__contentsBox__tabList li').removeClass('is-active');
            $(this).addClass('is-active');
            $('.p-topSetContents__contentsBox__contentsList__itemBox').removeClass('is-active').eq(index).addClass('is-active');
        });
        const mySwiper3 = new Swiper ('.p-topRanking__rankingBox__rankingList--pc .swiper-container', {
            loop: true,
            speed: 600,
            slidesPerView: 4,
            // centeredSlides : true,
            spaceBetween: 35,
            direction: 'horizontal',
            effect: 'slide',
            autoplay: {
                delay: 3000,
                stopOnLast: false,
                disableOnInteraction: true
            },
            breakpoints: {
                // 980: {
                //   slidesPerView: 3,
                //   spaceBetween: 30
                // },
                767: {
                    slidesPerView: 2,
                }
            },
        });
        $('.p-topRanking__rankingBox__tabList li').click(function() {
            const index = $('.p-topRanking__rankingBox__tabList li').index(this);
            $('.p-topRanking__rankingBox__tabList li').removeClass('is-active');
            $(this).addClass('is-active');
            $('.p-topRanking__rankingBox__rankingList__itemList').removeClass('is-active').eq(index).addClass('is-active');
            const mySwiper4 = new Swiper ('.p-topRanking__rankingBox__rankingList .swiper-container', {
                loop: true,
                speed: 600,
                slidesPerView: 4,
                // centeredSlides : true,
                spaceBetween: 35,
                direction: 'horizontal',
                effect: 'slide',
                autoplay: {
                    delay: 3000,
                    stopOnLast: false,
                    disableOnInteraction: true
                },
                breakpoints: {
                    // 980: {
                    //   slidesPerView: 3,
                    //   spaceBetween: 30
                    // },
                    767: {
                        slidesPerView: 2,
                    }
                },
            });
        });
        $('.p-topRanking__rankingBox__tabList li').click(function() {
            const index = $('.p-topRanking__rankingBox__tabList li').index(this);
            $('.p-topRanking__rankingBox__tabList li').removeClass('is-active');
            $(this).addClass('is-active');
            $('.p-topRanking__rankingBox__rankingList__itemList--sp').removeClass('is-active').eq(index).addClass('is-active');
        });
        const mySwiper5 = new Swiper ('.p-topInstagram__instagramList .swiper-container', {
            loop: true,
            speed: 600,
            slidesPerView: 5.1,
            centeredSlides : true,
            spaceBetween: 35,
            direction: 'horizontal',
            effect: 'slide',
            autoplay: {
                delay: 3000,
                stopOnLast: false,
                disableOnInteraction: true
            },
            breakpoints: {
                // 980: {
                //   slidesPerView: 3,
                //   spaceBetween: 30
                // },
                767: {
                    slidesPerView: 1,
                    spaceBetween: 17,
                }
            },
        });
        const mySwiper6 = new Swiper ('.p-mainVisual__mainVisualList .swiper-container', {
            loop: true,
            speed: 600,
            slidesPerView: 1.2,
            centeredSlides : true,
            spaceBetween: 40,
            direction: 'horizontal',
            effect: 'fade',
            autoplay: {
                delay: 3000,
                stopOnLast: false,
                disableOnInteraction: true
            },
            breakpoints: {
                // 980: {
                //   slidesPerView: 3,
                //   spaceBetween: 30
                // },
                767: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            },
        });
    };
    // get api/news/
    getNews()
        .then((news)=>{
            const $news = $('#news');
            let html = '';
            for (const a of news) {
                html = html + newsNode(a);
            }
            $news.html(html);
        });

    // get api/blog/
    getBlog()
        .then((blog)=>{
            const $blog = $('#blog');
            let html = '';
            for (const b of blog) {
                html = html + blogNode(b);
            }
            $blog.html(html);
        });
    function newsNode(a) {
        const date = moment(a.date);

        return `
                           <li>
                            <article class="p-topNews__newsList__newsBox">
                                <p class="p-topNews__newsList__newsBox__pubDate">${date.format('YYYY/MM/DD')}</p>
                                <div class="p-topNews__newsList__newsBox__infoBox">
                                    <h2 class="p-topNews__newsList__newsBox__infoBox__title">${a.title}</h2>
                                    <p class="p-topNews__newsList__newsBox__infoBox__description">${a.content}</p>
                                    <p class="p-topNews__newsList__newsBox__infoBox__link">

                                    </p>
                                </div>
                            </article>
                        </li>`;
    }
    function blogNode(b) {
        const date = moment(b.date);
        let category_html = '';
        for (const c of b.categories) {
            category_html = category_html + '<li>#' + c + '</li>';
        }
        return `
                        <li>
                            <a href="${b.url}">
                                <article class="p-topBlog__blogList__blogBox">
                                    <div class="p-topBlog__blogList__blogBox__thumbnail" style="background-image: url('${b.image}');"></div>
                                    <div class="p-topBlog__blogList__blogBox__infoBox">
                                        <h3 class="p-topBlog__blogList__blogBox__infoBox__title">${b.title}</h3>
                                        <div class="p-topBlog__blogList__blogBox__infoBox__subInfoBox">
                                            <p class="p-topBlog__blogList__blogBox__infoBox__subInfoBox__pubDate">${date.format('YYYY/MM/DD')}</p>
                                            <div class="p-topBlog__blogList__blogBox__infoBox__subInfoBox__tagList">
                                                <ul>${category_html}</ul>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            </a>
                        </li>`;
    }


    /**
     * モーダルがらみ
     */
    $(document).on('lity:close', function(event, instance) {
        $('#selector_wrap_confectioneryModal').fadeIn(0);
        $('#detail_wrap_confectioneryModal').fadeOut(0);
        $('#selector_wrap_luckyCharmModal').fadeIn(0);
        $('#detail_wrap_luckyCharmModal').fadeOut(0);
        $('#selector_wrap_boxModal').fadeIn(0);
        $('#detail_wrap_boxModal').fadeOut(0);
        $('#selector_wrap_cardModal').fadeIn(0);
        $('#detail_wrap_cardModal').fadeOut(0);
        scroll_top = 0;
    });
    $('.openDetailInModal').on('click',function () {
        modal_id = _.escape($(this).data('modal_id'));
        scroll_top = $('#' + modal_id).scrollTop();
        const item_id = _.escape($(this).data('item_id'));
        createDetailInModal(item_id)
            .then(()=>{
                $('#selector_wrap_' + modal_id).fadeOut(100);
                $('#detail_wrap_' + modal_id).fadeIn(300);
                $('#' + modal_id).scrollTop(0);
            });
    });
    $('.backToSelector').on('click',function () {
        $('.detail_wrap').fadeOut(100);
        $('.selector_wrap').fadeIn(300);
        $('#' + modal_id).scrollTop(scroll_top);
    });
    const createDetailInModal = (item_id) => new Promise((resolve, reject) => {
        getItem(item_id)
            .then((data) => {
                $('.modalImage').attr('src',data.image_main_tmbs[3]);
                $('.modalItemName').html(data.item_name);
                $('.modalDescription').html(data.description.replace(/\r?\n/g, '<br>'));
                let html = '';
                for ( let add_info of data.additional_info) {
                    html = html + `<tr><th>${add_info.k}</th><td>${add_info.v.replace(/\r?\n/g, '<br>')}</td></tr>`;
                }
                $('.modalAdditionalInfo').html(html);
                let sub_image_html =  `<li><img class="select_image" src="${data.image_main_tmbs[3]}" alt=""></li>`;
                for ( let image of data.images_sub) {
                    sub_image_html = sub_image_html + `<li><img class="select_image" src="${image[3]}" alt=""></li>`;
                }
                $('.modalSubImage').html(sub_image_html);
                // sub_image 画像切り替え
                $('.select_image').on('click',function () {
                    const src = $(this).attr('src');
                    $('.modalImage').attr('src',src);
                });
                resolve();
            })
            .catch((em) => {
                reject(em);
            })
    });
    const showErrorModal = (em) => {
        console.log(em);
        $('#loading-wrapper').hide();
        let error_message = '以下の項目をご確認ください。<br><br>';
        for (const m of em) {
            console.log(m);
            if (error_message !== '') {
                error_message = error_message + m + '<br>';
            } else {
                error_message = m + '<br>';
            }
        }
        $('#messageModalLabelError').html(error_message);
        myLity = lity('#messageModal');
    };
    $('.logout').on('click',function () {
        $loader.css('display','block');
        logout()
            .then(() => {
                location.href = '/';
            })
            .catch((em) => {
                $loader.css('display','none');
                showErrorModal([em]);
            })
    });
    $('#loginClick').on('click',function () {
        $loader.css('display','block');
        const email = _.escape(document.getElementById('email').value);
        const password = _.escape(document.getElementById('password').value);
        login(email,password)
            .then((result) => {
                sessionStorage.auth = JSON.stringify(result);
                isLogin()
                    .then(() => {
                        auth = JSON.parse(sessionStorage.getItem('auth'));
                        user = JSON.parse(sessionStorage.getItem('user'));
                        if (whichDevice() === 'sp') {
                            location.href='/mypage/sp';
                        } else {
                            location.href='/mypage';
                        }
                    })
                    .catch(() => {
                        reject();
                    });
            })
            .catch((em) => {
                $loader.css('display','none');
                showErrorModal(['ログイン出来ませんでした。メールアドレスまたはパスワードをご確認ください。']);
            })
    });
    $('iframe').each(function(){
        $(this).attr('src',$(this).attr('src')+'?wmode=transparent');
    })
    /**
     * PCくりぬきスライド
     */
    let slide_index = 0;
    let current_index = 0;
    const slide_index_max = 3;
    $('.swiper-button-prev').on('click',function () {
        prevSide();
    });
    $('.swiper-button-next').on('click',function () {
        nextSide();
    });
    function prevSide() {
        current_index = slide_index;
        slide_index--;
        if (slide_index < 0) {
            slide_index = 3;
        }
        changeSlide('prev');
        clearInterval(timerObj);
    }
    function nextSide() {
        current_index = slide_index;
        slide_index++;
        if (slide_index > slide_index_max) {
            slide_index = 0;
        }
        changeSlide('next');
        clearInterval(timerObj);
    }
    function forward() {
        current_index = slide_index;
        slide_index++;
        if (slide_index > slide_index_max) {
            slide_index = 0;
        }
        changeSlide('next');
    }
    function changeSlide() {
        $('#slide_pc_mac_' + current_index).fadeOut(300);
        $('#slide_pc_iphone_' + current_index).fadeOut(300);
        $('#slide_sp_' + current_index).fadeOut(300);
        $('#slide_pc_mac_' + slide_index).delay(300).hide().fadeIn(300);
        $('#slide_pc_iphone_' + slide_index).delay(300).hide().fadeIn(300);
        $('#slide_sp_' + slide_index).delay(300).hide().fadeIn(300);
    }
    const timerObj = setInterval(function(){ forward(); }, 3500);
    function whichDevice() {
        const ua = navigator.userAgent;
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
            return 'sp';
        } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
            return 'tablet';
        } else {
            return 'pc';
        }
    }
}());
